import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.billing-accounts')
  .factory('BillingAccountsAPI', BillingAccountsAPI);

function BillingAccountsAPI(): BringozApi {
  return {
    base: `/billingAccounts`,
    infiniteScroll: {
      address: `/billingAccounts`,
      cmd: 'GET'
    },
    actions: {
      getBillingAccount: {
        address: '',
        cmd: 'GET',
        updateable: false
      },
      getAccountsById: {
        address: '{id}/account',
        cmd: 'GET',
        updateable: false
      },
      createDeal: {
        address: 'actions/deal',
        cmd: 'POST',
        updateable: false
      },
      addCredit: {
        address: 'actions/credit',
        cmd: 'POST',
        updateable: false
      },
      addDebit: {
        address: 'actions/debit',
        cmd: 'POST',
        updateable: false
      },
      export: {
        address: 'actions/export',
        cmd: 'POST',
        updateable: false
      },
      addDoc: {
        address: 'actions/document',
        cmd: 'POST',
        updateable: false
      },
      createInvoice: {
        address: 'actions/invoice',
        cmd: 'POST',
        updateable: false
      },
      createInverc: {
        address: 'actions/inverc',
        cmd: 'POST'
      },
      charge: {
        address: 'actions/charge',
        cmd: 'POST',
        updateable: false
      },
      closeReceiptsDocuments: {
        address: 'closeReceiptsDocuments',
        cmd: 'POST'
      },
      createReceipt: {
        address: 'actions/receipt',
        cmd: 'POST'
      },
      getTransactions: {
        address: 'transactions',
        cmd: 'GET'
      },
      getProcessor: {
        address: 'paymentMethods/processor',
        cmd: 'GET'
      },
      addPaymentMethod: {
        address: 'paymentMethods/{token}',
        cmd: 'POST'
      },
      getProcessorToken: {
        address: 'paymentMethods/processor',
        cmd: 'GET'
      },
      removePaymentMethod: {
        address: 'paymentMethods/{pmToken}',
        cmd: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      refund: {
        address: 'transactions/{transactionId}/refund',
        cmd: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      getPreferences: {
        address: '{billingAccountId}/preferences',
        cmd: 'GET',
      },
      updatePreferences: {
        address: '{billingAccountId}/preferences',
        cmd: 'POST',
        updateable: true
      },
      update: {
        address: '{billingAccountId}',
        cmd: 'POST',
        updateable: true
      }
    }
  }
}
